import * as api from "@/api/williams/renewals";
import { getFullPath, routes } from "../../routes";
import { Renewal } from "@/api/williams/renewals";
import { useMutation } from "react-query";
import { useNavigate } from "react-router";

export function useAddRenewal() {
  const navigate = useNavigate();

  return useMutation(async (renewal: Renewal) => {
    await api.addRenewal(renewal);
    navigate(getFullPath(routes.welder.list("expirations")), {
      replace: true,
      state: {
        skipSavePrompt: true,
      },
    });
  });
}
